import type { Dispatch, SetStateAction } from 'react';
import type { RefCarePlanProblemResponse } from '~/lib/types/carePlan/RefCarePlanProblemResponse';
import type { RefCarePlanManifestationResponse } from '~/lib/types/carePlan/RefCarePlanManifestationResponse';
import type { ManifestationCodeToEditableDataMap } from '~/lib/types/carePlan/ManifestationCodeToEditableDataMap';
import { AddProblemModalManifestationsStep } from '~/components/maud/patients/profile/tabs/careplan/AddProblemModalManifestationsStep';
import type {
  EdProblemDetails,
  ProblemDetails,
} from '~/components/maud/patients/profile/tabs/careplan/CarePlanProblemDialogManager';

export type ProblemDetailsEdCardProps = {
  details: EdProblemDetails;
  manifestationsForED: RefCarePlanManifestationResponse[];
  modalId: string;
  problem: RefCarePlanProblemResponse;
  updateProblemDetails: (problemCode: string, next: ProblemDetails) => void;
};

export const ProblemDetailsEdCard = ({
  details,
  manifestationsForED,
  modalId,
  problem,
  updateProblemDetails,
}: ProblemDetailsEdCardProps) => {
  const setProblemDescription: Dispatch<SetStateAction<string>> = (next) => {
    const resolved =
      typeof next === 'function' ? next(details.description) : next;
    updateProblemDetails(problem.code, { ...details, description: resolved });
  };

  const setProblemFrequencyCode: Dispatch<
    SetStateAction<string | undefined>
  > = (next) => {
    const resolved =
      typeof next === 'function' ? next(details.frequencyCode) : next;
    updateProblemDetails(problem.code, {
      ...details,
      frequencyCode: resolved,
    });
  };

  const setSelectedManifestationsMap: Dispatch<
    SetStateAction<ManifestationCodeToEditableDataMap>
  > = (next) => {
    const resolved =
      typeof next === 'function' ? next(details.manifestationsMap) : next;
    updateProblemDetails(problem.code, {
      ...details,
      manifestationsMap: resolved,
    });
  };

  return (
    <AddProblemModalManifestationsStep
      manifestationsForED={manifestationsForED}
      modalId={modalId}
      problem={problem}
      problemDescription={details.description}
      problemFrequencyCode={details.frequencyCode}
      selectedManifestationsMap={details.manifestationsMap}
      setProblemDescription={setProblemDescription}
      setProblemFrequencyCode={setProblemFrequencyCode}
      setSelectedManifestationsMap={setSelectedManifestationsMap}
    />
  );
};
